module.exports = "/images/vendor/@milestoneslabs/milestones-ui-kit/src/static/project-icons/home-purchase.svg?30b1847a5e89577f85717b36a248b583";